import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Editing,
  Texts,
  Button,
  Form,
  StateStoring,
  HeaderFilter,
  SearchPanel,
  RequiredRule,
  Popup as Popup2,
  LoadPanel,
  Export,
  Grouping,
  FilterPanel,
  Scrolling,
  Selection,
  Summary
} from 'devextreme-react/data-grid';
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import {Tooltip} from 'devextreme-react';
import { Item } from 'devextreme-react/form';
import DataSource from 'devextreme/data/data_source';
import { useHistory } from "react-router";
import { Popup, Position } from 'devextreme-react/popup';
// import { DateRangePicker } from 'react-date-range';
import { addDays, addHours } from 'date-fns';
import { Button as Button2 } from 'devextreme-react/button';
import { CheckBox } from 'devextreme-react/check-box';
import ScrollView from 'devextreme-react/scroll-view';
import DOMPurify from 'dompurify';
import TenantService from 'api/tenant.service';
import AssetsService from 'api/assets.service';
import {Button as SelectButton} from 'devextreme-react/button';
// import socketIO from 'socket.io-client';
import FloorplanPopup from 'pages/components/floorplan'; //TODO: component is getting called from wrong place
import Toast from 'components/Toast';
import Form2 from './axiosUpload.js'; //TODO: change Form2 naming
import './assets.css';
import moment from 'moment-timezone';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer.js';
// import ConfirmDeleteModal from 'components/ConfirmDeleteModal';

import {
  Form as DxForm,
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule as DxFormRequiredRules
} from 'devextreme-react/form';


const dataSource = new DataSource({
  store: [],
  key: 'id',
  searchMode: 'delay', // Use 'delay' mode for better user experience
  searchTimeout: 800, // Delay in milliseconds
})
dataSource._userData = {edit: false};

export default function Assets(props) {
  const [data, setData] = useState([])
  const [attributes, setAttributes] = useState([])
  const [types, setTypes] = useState([])
  const [devices, setDevices] = useState([])
  const [popupVisibleColumnChooser, setPopupVisibleColumnChooser] = useState(false)
  const [spaceId, setSpaceId] = useState("")
  const [popupVisible, setPopupVisible] = useState(false)
  const [popupVisible2, setPopupVisible2] = useState(false)
  const [uploadPopupVisible, setUploadPopupVisible] = useState(false)
  const [assetCoords, setAssetCoords] = useState([])
  const [spaceName, setSpaceName] = useState("")
  const [btnText, setBtnText] = useState("Select Date Range")
  const [isActive, setActive] = useState(false)
  const [visibleColumnChooser, setVisibleColumnChooser] = useState(true)
  const [forceUpdate, setForceUpdate] = useState(false)
  const [apiInProgress, setApiInProgress] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading assets...');
  const [heightOfGrid, setHeightOfGrid] = useState('calc(100vh - 102px)');
  const [loading, setLoading] = useState(false);
  const [socket, setSocket] = useState(null)
  const [temporarySelection, setTemporarySelection] = useState([]);
  const [finalSelection, setFinalSelection] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true)
  const [disableClass, setDisableClass] = useState("") //disable-analyze
  const [selectedRowsCount, setSelectedRowsCount] = useState(0)
  // const [toDeleteRow, setToDeleteRow] = useState(null);
  // const [rowToDelete, setRowToDelete] = useState(null);
  // const [modalVisible, setModalVisible] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const formRef = useRef();
  const dxFormRef = useRef();
  const pendingSelectionRef = useRef(null);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [assetToDelete, setAssetToDelete] = useState(null);

  const [formData, setFormData] = useState({
    id: null,
    name: '',
    type: '',
    pairedDevice: null,
    attributes: {},
  });
  const [prevData, setPrevData] = useState(null)
  const [attributeFields, setAttributeFields] = useState([]);
  const [attributeChanges, setAttributeChanges] = useState({});

  function exportGrid(e) {
    const workbook = new Workbook(); 
    const worksheet = workbook.addWorksheet("Assets");
    worksheet.columns = [
          { width: 5 },
          { width: 30 },
          { width: 25 },
          { width: 15 },
          { width: 25 },
          { width: 40 },
        ];
    exportDataGrid({
          component: e.component,
          worksheet,
          keepColumnWidths: false,
          topLeftCell: { row: 1, column: 1 },
          customizeCell: ({ gridCell, excelCell }) => {
            if (gridCell.rowType === 'data') {
              if (gridCell.column.dataField === 'lastKnownLocation.timestamp') {
                const utcDate = new Date(gridCell.value);
                excelCell.value = utcDate.toLocaleString('en-US', {
                  weekday: 'short',
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true
                });
              }
            }
          },
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Assets-${moment().format('YYYY-MM-DD-HH-mm-ss')}.xlsx`);
          });
        })
    e.cancel = true; 
  }

  const [state3, setState3] = useState([
    {
      devicesId: [],
      devices: [],
      selectedRow: -1,
    }
  ]);
  const [state2, setState2] = useState([
    {
      startDate: addDays(new Date(), - 7),
      endDate: new Date(),
      key: 'selection',
    }
  ]);
  const tenant = TenantService.getTenant()
  const history = useHistory();
  const dropDataGridRef = useRef();
  const downloadTargetRef = useRef();
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  });
  const getToken = () => {
    const token = localStorage.getItem('token');
    if (!token || token === "accessToken") {
    } else {
      return token;
    }
  }

  const handleOptionChanged = (e) => {
    if (pendingSelectionRef.current?.length > 0 && dataSource.store()._array.length > 0) {
      e.component.selectRows(pendingSelectionRef.current, false);
      pendingSelectionRef.current = null;
    }
    if (e.fullName === 'filterValue') {
      dataSource.load().then((result) => {
      });
    }
  }

  const exportData = (e) => {
    const gridInstance = dropDataGridRef.current.instance();
    
    const filters = gridInstance.getCombinedFilter(); // Get all applied filters
    // const itemsData = gridInstance.getDataSource()._items
    // const ids = itemsData.map(item => item.id);

    // Load the filtered data
    dataSource.store().load({
      filter: filters,
      // You can add sorting, pagination, etc. if needed here
    }).then((items) => {
      const ids = items.map(item => item.id);
      localStorage.setItem(`analyze-filter-data-${tenant}`, JSON.stringify(ids));
    });
    history.push('/assets/analyze');
  }

  const getMultipleSelection = () => {
    if (dropDataGridRef.current) {
      const selectedRows = dropDataGridRef.current.instance().getSelectedRowsData();
      console.log("selectedRows",selectedRows)      
      localStorage.setItem(`multiple-asset-selection-records-${tenant}`, JSON.stringify(selectedRows));
      const ids = selectedRows.map(item => item.id);
      const names = selectedRows.map(item => item.name);
      // if (selectedRows.length === 1){
      //   history.push({
      //     pathname: `/asset/${selectedRows[0].id}`,
      //     state: {
      //       id: ids,
      //       name: names
      //     }
      //   });
      //   return;
      // }
      
      if (ids.length > 1){
        localStorage.setItem(`multiple-asset-selection-ids-${tenant}`, JSON.stringify(ids));
        history.push({
          pathname: '/asset/tab',
          state: {
            id: ids,
            name: names
          }
        })
      } else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: "",
          message: "Must select more than 1 asset!",
        });
        // add toast
      }
      
      // history.push({
      //   pathname: `/asset/${selectedRows[0].id}`,
      //   state: {
      //     data: ids
      //   }
      // })
    }
  }
  
  const downloadReport = () => {
    const grid = dropDataGridRef.current.instance();
    const filters = grid.getCombinedFilter();
    // const dataSource = grid.getDataSource();
    // const allData = dataSource.items();
    dataSource.store().load({
      filter: filters,
      // You can add sorting, pagination, etc. if needed here
    }).then((items) => {
      const columns = grid.getVisibleColumns()
      .filter(col => col.dataField)
      .map(col => ({
        header: col.caption,
        dataField: col.dataField
      }));
  
    const rows = items.map(row => {
      return columns.map(col => {
        const nestedKeys = col.dataField.split('.');
        let value = row;
        nestedKeys.forEach(key => {
          if (value && typeof value === 'object') {
            value = value[key];
          } else {
            value = undefined;
          }
        });
        if (col.dataField === 'lastKnownLocation.timestamp' && value !== '' && value !== undefined && value !== null) {
          value = new Date(value).toLocaleString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
          });
        }
        return value;
      });
    });
  
    const doc = new jsPDF();
    doc.autoTable({
      head: [columns.map(col => col.header)],
      body: rows,
      headStyles: {
        fillColor: [181, 22, 22], // Red color
        textColor: [255, 255, 255] // White text color
      }
    });
    doc.save(`Assets-${moment().format('YYYY-MM-DD-HH-mm-ss')}.pdf`);
    })
  
    
  };

  async function getData(applyD, yes, reload) {
    if (dataSource._userData?.edit) return null;
    
    // Set loading state for initial data load
    if (yes === true) {
      setLoading(true);
    }
    
    let markers = []
    if (props.location !== undefined) {
      if (props.location.state !== undefined) {
        if (props.location.state.markers !== undefined) {
          markers = props.location.state.markers
        }
      }
    }
    let from = null
    let to = null
    let to1 = null
    if (applyD === true) {
      from = state2[0].startDate
      to1 = state2[0].endDate
      to = addDays(to1, 1)
      localStorage.setItem(tenant + "dateFilterFrom", from.toDateString())
      localStorage.setItem(tenant + "dateFilterTo", to.toDateString())
      localStorage.setItem(tenant + "dateFilterText", `${from.toDateString()} - 
      ${to1.toDateString()}`)
      setBtnText(`${from.toDateString()} - 
      ${to1.toDateString()}`)
    } else if (applyD === "inventory") {
      from = addHours(new Date(), -2)
      to = new Date()
      localStorage.setItem(tenant + "dateFilterFrom", from.toDateString())
      localStorage.setItem(tenant + "dateFilterTo", to.toDateString())
      localStorage.setItem(tenant + "dateFilterText", "Inventory")
      setBtnText("Inventory")
    } else if ((localStorage.getItem(tenant + "dateFilterFrom") !== null || localStorage.getItem(tenant + "dateFilterFrom") !== "null") && applyD !== false) {
      from = Date.parse(localStorage.getItem(tenant + "dateFilterFrom"))
      to = Date.parse(localStorage.getItem(tenant + "dateFilterTo"))
      to1 = "test"
      let myBtnText = localStorage.getItem(tenant + "dateFilterText")
      if (myBtnText !== null) {
        setBtnText(localStorage.getItem(tenant + "dateFilterText"))
      }
    }
    else if (applyD === false) {
      from = null
      to = null
      setBtnText("Select Date Range")
    }
    if (yes === true) {
      try {
        const storedState = JSON.parse(localStorage.getItem(tenant + "assets"));
        pendingSelectionRef.current = storedState?.selectedRowKeys || null;

        const value = await AssetsService.getAssets(tenant, null, null);
        let assets = value.data.data
        setLoadingText("No Data");
        if (markers.length !== 0) {
          let assetsToShow = assets.filter(asset => {
            return markers.find(marker => {
              return marker === asset.id
            })
          })
          assetsToShow.forEach(obj => {
            const wearLevel = obj.attributes?.wear_level;
            // Check if wear_level is not null and cast it to an integer
            if (wearLevel !== null && wearLevel !== undefined) {
                obj.attributes.wear_level = parseInt(wearLevel, 10);
            }
          });

          appendAssetsData(assetsToShow);
        } else {
          value.data.data.forEach(obj => {
            const wearLevel = obj.attributes?.wear_level;

            // Check if wear_level is not null and cast it to an integer
            if (wearLevel !== null && wearLevel !== undefined) {
                obj.attributes.wear_level = parseInt(wearLevel, 10);
            }
          });
          appendAssetsData(value.data.data);
          localStorage.setItem(`total-assets-count-${tenant}`, value.data.data.length);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error loading assets:', error);
        setLoading(false);
      }
    } else {
      getAttributes()
      setData([])
    }
  }

  function appendAssetsData(newRecords){
    dataSource.store()._array = newRecords;
    return dataSource.reload();
  }

  function getAttributes() {
    AssetsService.getTenantAssetTypeAttributes(tenant).then((value) => {
      let response = value?.data
      setAttributes(response?.data)
    })
  }

  // TODO: All these methods needs to change/remove----start>>
  function onEditorPreparing(e) {
    if(e.visible && e.parentType === 'dataRow') {
      // dataSource._userData = {edit: true}
    }
  }

  function onEditCanceled() {
    dataSource._userData = {edit: false}
  }

  // useEffect(()=> {
  //   const socketClient = socketIO.connect(`${process.env.REACT_APP_API_URL}`, {forceNew: true, path:"/api/socket/"});
  //   setSocket(socketClient)
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'visible') {
  //       if (!socketClient.connected) {
  //         socketClient.connect();
  //       }
  //     }
  //   };

  //   // Add an event listener for visibility change
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
    
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //     socketClient.disconnect();
  //   };


  // },[])

  useEffect(async() => {
    await getAttributes();
    await getTypes();
    // Remove getDevices() call from here as it's only needed for editing
  }, [apiInProgress]);

  // TODO: All these methods needs to change/remove----<<<end

  async function startEdit(index) {
    // await dropDataGridRef.current.instance().editRow(index);
  }

  function onSubmit(data){
    setEditingRow(null)
    setIsOpen(false)
  }

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const result = dxFormRef.current?.validate?.();
      if (result?.isValid) {
        if(formData && formData.id){
          onRowUpdate()
        }else{
          onAddRow()
        }
        handleCloseDrawer();
      }
    },
    [formData, handleCloseDrawer]
  );


  function onAddRow() {
    setLoading(true)
    let pairedDeviceId = formData.pairedDevice
    if (pairedDeviceId === "null") {
      pairedDeviceId = null
    }
    AssetsService.addAsset(formData.name, formData.type, tenant, pairedDeviceId, attributeChanges).then(async (asset) => {
      await setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: asset.status===200 ? 'success' : 'error',
        status: asset?.data?.status ? asset.data.status : asset?.status,
        message: asset?.data?.message ? asset.data.message : asset?.message,
      });
      setTimeout(() => {
        window.location.reload()
      }, 3000);
    })
  }

  function onRowUpdate(e) {
    const { id, name, type, pairedDevice } = formData;
    let deviceId = null;
    if (pairedDevice && pairedDevice !== "null") {
      deviceId = pairedDevice;
    }
    setLoading(true);
    AssetsService.editAsset(id, name, type, deviceId).then((asset) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: asset?.status === 200 ? 'success' : 'error',
        status: asset?.data?.status || asset?.status,
        message: asset?.data?.message || asset?.message,
      });

      Promise.all(
        Object.entries(attributeChanges).map(([k, v]) => AssetsService.editAsset(id, undefined, undefined, undefined, { [k]: v }))
      ).then(() => getData(null, true, false));
    }).catch((error) => {
      console.error('Error updating asset:', error);
      setLoading(false);
    });
  }


  const handleSave = () => {
    formRef.current?.requestSubmit(); // 🔥 trigger native submit
  };

  function handleCloseDrawer(){
    setEditingRow(null)
    setFormData({
      name: "",
      type: "",
      pairedDevice: "",
      attributes: {},
    })
    setAttributeFields([]);
    setAttributeChanges({});
    setIsOpen(false)
  }

  function handleAssetType(e){
    if (!e?.selectedItem) return;
    setFormData((prev) => ({
      ...prev,
      type: e.selectedItem
    }));
  }

  function handlePairedDevice(e){
    if (!e?.selectedItem) return;
    setFormData((prev) => ({
      ...prev,
      pairedDevice: e.selectedItem
    }));
  }

  function handleNameChange(e){
    setEditingRow((prev) => ({
      ...prev,
      name: e.value
    }));
  }

  async function editRow(e) {
    const rowData = e.row?.data;
    if (!rowData) return;

    setEditingRow(rowData);
    setFormData({
      id: rowData.id,
      name: rowData.name,
      type: rowData.type?.id,
      pairedDevice: rowData.pairedDevice?.id ?? "null",
      attributes: {},
    });
    setPrevData({
      id: rowData.id,
      name: rowData.name,
      type: rowData.type?.id,
      pairedDevice: rowData.pairedDevice?.id ?? "null"
    });
    setLoading(true);
    await getDevices(rowData.pairedDevice, e.row.dataIndex);

    try {
      const [assetRes, attrFieldsRes] = await Promise.all([
        AssetsService.getAsset(rowData.id),
        rowData.type?.id ? AssetsService.getAssetTypeAttributes(rowData.type.id) : Promise.resolve(null),
      ]);
      const attrs = assetRes?.data?.data?.attributes || {};
      setFormData(prev => ({ ...prev, attributes: attrs }));
      setAttributeChanges({});
      if (attrFieldsRes) {
        setAttributeFields(attrFieldsRes.data.data || []);
      }
    } catch (err) {
      console.error('Error loading asset attributes:', err);
    }

    setIsOpen(true);
  }

  async function getDevices(currentDevice, row) {
    try {
      const value = await AssetsService.getAssetTagsToPair(tenant);
      let response = value.data
      // let serials = []
      let serialsId = []
      let serials = [
        { serialNumber: "Unpaired", id: "null" }
      ];
      serialsId.push(null)
      if (currentDevice?.id && currentDevice?.serialNumber){
        serials.push({
          serialNumber: currentDevice.serialNumber,
          id: currentDevice.id
        })
      }
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].freeToPair) {
          serials.push({
            serialNumber: response.data[i].serialNumber,
            id: response.data[i].id
          })
          serialsId.push(response.data[i].id)
        }
      }
      // setState3({
      //   devicesId: serialsId,
      //   devices: serials,
      //   selectedRow: row,
      // })
      // setDevices(serials)
      // Ensure state update before rendering
      await new Promise(resolve => {
        setDevices([...serials]);  // Spread operator to trigger re-render
        setState3({
          devicesId: serialsId,
          devices: serials,
          selectedRow: row
        });
        resolve();
      });
      setLoading(false)
      if(currentDevice?.id){
        setIsOpen(true)
      }
    } catch (error) {
      console.error('Error fetching devices:', error);
      setLoading(false);
    }
  }

  async function handleAdd(){
    setLoading(true);
    await getDevices(null, null); // Pass null for currentDevice and row
    setIsOpen(true);
  }

  function getTypes() {
    AssetsService.getAssetTenantTypes(tenant).then((value) => {
      let response = value.data
      let names = []
      let namesId = []
      for (let i = 0; i < response.data.length; i++) {
        names.push({
          name: response.data[i].name,
          id: response.data[i].id
        })
        namesId.push(response.data[i].id)
      }
      setTypes(names)
    })
  }

  function onRowInserting(e) {
    if (e.data.type === undefined) {
    }
  }

  async function onStatusUpdate(e) {
    console.log("onStatusUpdate")
    let assetsLocalStorage = JSON.parse(localStorage.getItem(tenant + "assets"));
    console.log("assetsLocalStorage", assetsLocalStorage)
    assetsLocalStorage.searchText = e;
    localStorage.setItem(tenant + "assets", JSON.stringify(assetsLocalStorage));
  }

  function onRowInserted(e) {
    let pairedDeviceId = e.data.pairedDevice.id
    if (pairedDeviceId === "null") {
      pairedDeviceId = null
    }
    AssetsService.addAsset(e.data.name, e.data.type.id, tenant, pairedDeviceId).then(async (asset) => {
      await setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: asset.status===200 ? 'success' : 'error',
        status: asset?.data?.status ? asset.data.status : asset?.status,
        message: asset?.data?.message ? asset.data.message : asset?.message,
      });
      setTimeout(() => {
        window.location.reload()
      }, 3000);
    })
  }

  function handleDeleteClick(e) {
    const rowData = e.row?.data;
    if (!rowData) return;
    
    setAssetToDelete(rowData);
    setDeleteConfirmVisible(true);
  }

  function confirmDelete() {
    if (!assetToDelete) return;
    setDeleteConfirmVisible(false);
    setLoading(true);
    AssetsService.deleteAsset(assetToDelete.id).then((asset) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: asset.status===200 ? 'success' : 'error',
        status: asset?.data?.status ? asset?.data?.status : asset?.status,
        message: asset?.data?.message ? asset.data.message : asset?.message,
      });
      setTimeout(() => {
        window.location.reload()
      }, 2000);
    }).finally(() => {
      setAssetToDelete(null);
      setLoading(false);
    });
  }

  function cancelDelete() {
    setDeleteConfirmVisible(false);
    setAssetToDelete(null);
  }

  function onRowRemoved(e) {
    // This function is now unused since we handle delete through custom confirmation
    // Keeping it for compatibility but it shouldn't be called
  }

  function buttonColor(e) {
    if ((e?.column?.dataField === 'lastKnownLocation.name') && e?.rowType !== "header" && e?.data !== undefined) {
      if (e?.data?.lastKnownLocation !== undefined) {
        if (e?.data?.lastKnownLocation?.name !== null) {
          e.cellElement.style.color = "#337ab7";
          e?.cellElement?.style.setProperty('cursor', 'pointer', 'important')
        }
      }
    }
    // if ((e?.column?.dataField === 'event') && e?.rowType !== "header" && e?.data !== undefined) {
    //   if (e?.data?.event !== undefined) {
    //     if (e?.data?.event !== null) {
    //       e.cellElement.style.color = "#337ab7";
    //       e?.cellElement?.style.setProperty('cursor', 'pointer', 'important')
    //     }
    //   }
    // }
    if ((e?.column?.dataField === 'name') && e?.rowType !== "header") {
      e.cellElement.style.color = "#337ab7";
      e.cellElement.style.setProperty('cursor', 'pointer', 'important')
    }
    if (e.column.dataField === 'status' && e.rowType !== "header") {
      if (e.data !== undefined) {
        if (e.data.status !== undefined) {
          if (e.data.status === 'online') {
            e.cellElement.style.color = "#12DF1C";
          } else if (e.data.status === 'offline') {
            e.cellElement.style.color = "#FF0000";
          } else{
            e.cellElement.style.color = "#FF0000";
          }
        }
      }
    }
  }

  function showInfo(e) {
    if (e.data){
      if (e.column.name === 'name') {
        e.cellElement.style.color = "#337ab7";
        history.push({
          pathname: '/asset/tab',
          state: {
            id: [e.data.id],
            name: [e.data.name]
          }
        })
      }

    
      if (e.column.name === 'lastKnownLocation.name' && e.data.lastKnownLocation?.name !== null) {
        setSpaceName(e.data.lastKnownLocation?.name)
        setAssetCoords({ coords: e.data.lastKnownLocation?.localCoordinates, serialNumber: e.data.name })
        setSpaceId(e.data.lastKnownLocation?.id)
        setPopupVisible(true)
      }
    }

    // const gridInstance = dropDataGridRef.current.instance;
    // const selected = gridInstance.getSelectedRowKeys();

    // Perform your custom action
    // if (selected.length > 0) {
    //   setIsDisabled(false)
    //   setDisableClass("")
    //   // setSelectedRowsCount(selected.length)
    // } else {
    //   setIsDisabled(true)
    //   setDisableClass("disable-analyze")
    //   // setSelectedRowsCount(0)
    // }
  }

  function onRowUpdating(e) {
    let name
    let typeId
    let deviceId
    // let pairedDeviceInfo
    if (e.newData.name !== undefined) {
      name = e.newData.name
    }
    if (e.newData.type !== undefined) {

      typeId = e.newData.type.id
    }
    if (e.newData.pairedDevice !== undefined) {
      if (e.newData.pairedDevice.id === "null") {
        deviceId = null
      } else {
        deviceId = e.newData.pairedDevice.id
      }

    } else if (e.oldData.pairedDevice !== undefined) {
      deviceId = e.oldData.pairedDevice.id
    } else {
      deviceId = null
    }
    // const updatedInfo = {
    //   id: e.oldData.id,
    //   name: e.newData?.name !== undefined ? e.newData?.name : e.oldData?.name,
    //   type: e.newData?.type !== undefined ? e.newData?.type : e.oldData?.type,
    //   pairedDevice: devices.find(item => item.id === deviceId)
    // }
    AssetsService.editAsset(e.oldData.id, name, typeId, deviceId).then((asset) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: asset?.status===200 ? 'success' : 'error',
        status: asset?.data?.status ? asset?.data?.status : asset.status,
        message: asset?.data?.message ? asset.data.message : asset.message,
      });
      // if(asset.status === 200){
      //   socket.emit(`editAsset`, {asset: updatedInfo, socketID: socket.id, tenant: tenant})
      // }
      getData(null, true, false);
    })

  }


  function floorplan() {
    if (popupVisible) {
      return (
        <FloorplanPopup spaceId={spaceId} myMarkers={[{ spaceCoordinates: assetCoords.coords, serialNumber: assetCoords.serialNumber }]} type={'assetsSpace'}>
        </FloorplanPopup>
      )
    } else {
      return (<></>)
    }
  }

  function showAttributes() {
    return (
      attributes.map((attribute, i) => {
        const isWearLevel = attribute.name === 'wear_level';
        return (
          <Column
            key={i}
            dataField={`attributes.${attribute.name}`}
            caption={attribute.display}
            dataType={isWearLevel ? 'number' : 'string'}
            fixed={true}
            visible={showColumn(attribute.name)}
            alignment={isWearLevel ? 'left' : ''}
          />
        );
      })
    );
  }

  function hideInfo() {
    setPopupVisible(false)
    setPopupVisibleColumnChooser(false)
  }

  const positionEditorOptions = {
    items: types,
    searchEnabled: true,
    // value: '',
    // acceptCustomValue: false,
    displayExpr: "name",
    valueExpr: "id"
  };

  const deviceEditorOptions = {
    dataSource: devices,
    searchEnabled: true,
    // value: '',
    // acceptCustomValue: false,
    displayExpr: "serialNumber",
    valueExpr: "id",
  };

  useEffect(() => {
    getToken()
    getData(null, true, false);
  }, []);

  // useEffect(() => {
  //   // this is from Redis subscribe mechanism
  //   if (socket === null) return false
  //   socket.on(`editAssetResponseRedis-${tenant}`, (data) => {
  //     var recordIndex = dataSource.store()._array.findIndex(function(item) {
  //       return item.id == data.id;
  //     });
    
  //     if (recordIndex !== -1) {
  //       // dataSource.store()._array[recordIndex].lastKnownLocation = data.lastKnownLocation
  //       // dataSource.store()._array[recordIndex].online = data.online
  //       // dataSource.reload();
        
  //       dataSource.store().update({id: data.id}, {
  //         online: data.online,
  //         lastKnownLocation: {
  //           name: data.lastKnownLocation.name,
  //           timestamp: data.lastKnownLocation.timestamp
  //         }
  //       });
  //       dataSource.load()
  //     }
  //   });

  //   // Update record
  //   socket.on(`editAssetResponse-${tenant}`, (data) => {
  //     var recordIndex = dataSource.store()._array.findIndex(function(item) {
  //       return item.id == data.asset.id;
  //     });
    
  //     if (recordIndex !== -1) {
  //       dataSource.store().update({id: data.id}, {
  //         name: data.asset.name,
  //         type: data.asset.type, 
  //         pairedDevice:data.asset.pairedDevice
  //       });
  //       dataSource.load()
  //     }
  //   });

  //   // Add record
  //   socket.on(`addAssetResponse-${tenant}`, (data) => {
  //     dataSource.store()._array.push(data)
  //     dataSource.load();
  //   });

  //   // Remove record
  //   socket.on(`deleteAssetResponse-${tenant}`, (data) => {
  //     var deleteIndex = dataSource.store()._array.findIndex(function(item) {
  //       return item.id == data;
  //     });
  //     dataSource.store()._array.splice(deleteIndex, 1)
  //     dataSource.load();
  //   });
  // }, [socket])


  function onHidingUpload() {
    setUploadPopupVisible(false)
    history.push({
      pathname: `/assets`,
      state3: {
        response: ""
      }
    })
  }

  function uploadClick(e) {
    setUploadPopupVisible(true)
  }

  function onInitialized() {
    if (localStorage.getItem("visibleColumnChooser") === "false") {
      setVisibleColumnChooser(false)
    } else if (localStorage.getItem("visibleColumnChooser") === "true") {
      setVisibleColumnChooser(true)
    } else {
      setVisibleColumnChooser(true)
    }
  }

  // function columnChooser(e) {
  //   setVisibleColumnChooser(!visibleColumnChooser)
  //   setPopupVisibleColumnChooser(!popupVisibleColumnChooser)
  //   localStorage.setItem("visibleColumnChooser", !visibleColumnChooser)
  // }
  function columnChooser(e) {
    const newVisibility = !popupVisibleColumnChooser;
    setPopupVisibleColumnChooser(newVisibility);
    
    const storedSelection = JSON.parse(localStorage.getItem(tenant + "visibleCols")) || [];
    setTemporarySelection(storedSelection);
    if (newVisibility) {
        setTemporarySelection(finalSelection); 
    }
    localStorage.setItem("visibleDeviceColumnChooser", newVisibility);
}

function hideInfoColumn() {
  setTemporarySelection([])
  const storedSelection = JSON.parse(localStorage.getItem(tenant + "visibleCols")) || [];
  setFinalSelection(storedSelection)
  setPopupVisibleColumnChooser(false)
}

  // function selectColumn(name) {
  //   var storedArray = JSON.parse(localStorage.getItem(tenant + "visibleCols"));
  //   if (storedArray === null) {
  //     storedArray = []
  //     storedArray.push({
  //       name: name,
  //       value: true
  //     })
  //     localStorage.setItem(tenant + "visibleCols", JSON.stringify(storedArray));
  //   } else {
  //     let found = false
  //     for (let i = 0; i < storedArray.length; i++) {
  //       if (storedArray[i].name === name) {
  //         storedArray[i].value = !storedArray[i].value
  //         found = true
  //       }
  //     }
  //     if (!found) {
  //       storedArray.push({
  //         name: name,
  //         value: true
  //       })
  //     }
  //     localStorage.setItem(tenant + "visibleCols", JSON.stringify(storedArray));
  //   }
  //   setForceUpdate(!forceUpdate)
  // }

  useEffect(() => {
    // Load initial selection from localStorage when the component mounts
    const storedSelection = JSON.parse(localStorage.getItem(tenant + "visibleCols")) || [];
    setFinalSelection(storedSelection); // Initialize final selection
  }, [tenant]);
  // const selectColumn = () => {
  //   const newSelection = finalSelection.filter(col => col.value);
  //   localStorage.setItem(tenant + "visibleCols", JSON.stringify(newSelection));
  //   setFinalSelection(newSelection); // Update final selection
  //   setPopupVisibleColumnChooser(false); // Close the popup
  // };
  const selectColumn = () => {
    setFinalSelection((prev) => {
      const newSelection = temporarySelection.filter(col => col.value);
      
      // Save to localStorage
      localStorage.setItem(tenant + "visibleCols", JSON.stringify(newSelection));
  
      // Close the popup
      setPopupVisibleColumnChooser(false);
  
      return newSelection;
    });
  };
  

  // const handleCheckboxChange = (name) => {
  //   setTemporarySelection((prev) => {
  //     const updatedSelection = [...prev];
  //     const index = updatedSelection.findIndex((col) => col.name === name);

  //     if (index > -1) {
  //       // Toggle the value if found
  //       updatedSelection[index].value = !updatedSelection[index].value;
  //     } else {
  //       // Add new column if not found
  //       updatedSelection.push({ name, value: true });
  //     }
  //     return updatedSelection;
  //   });
    
  // };

  const handleCheckboxChange = (name) => {
    setTemporarySelection((prev) => {
      const index = prev.findIndex((col) => col.name === name);
      
      if (index > -1) {
        // Toggle value if found
        return prev.map((col, i) =>
          i === index ? { ...col, value: !col.value } : col
        );
      } else {
        // Add new entry if not found
        return [...prev, { name, value: true }];
      }
    });
  };
  
  

  function chooserColumn() {
    return (
      <>

        <ScrollView width='100%' height='calc(100% - 40px)'>
          <div className='assets-columnChooserContainer'>
            {
              attributes.map((attribute, i) =>
                  <div key={i} className='assets-columnCheckbox'>
                    <CheckBox
                    value={temporarySelection.find((col) => col.name === attribute.name)?.value ?? false} 
                    onValueChange={() => handleCheckboxChange(attribute.name)}    
                    // value={showColumn(attribute.name)} 
                    />
                    &nbsp; {attribute.display}
                  </div>
              )
            }
            <div className='assets-columnCheckbox'>
              <CheckBox 
                value={temporarySelection.find((col) => col.name === 'pairedDevice.serialNumber')?.value}
                onValueChange={() => handleCheckboxChange('pairedDevice.serialNumber')}
                // value={showColumn("pairedDevice.serialNumber")} 
                />
              &nbsp; Paired Tag
            </div>
            <div className='assets-columnCheckbox' >
              <CheckBox 
              // value={showColumn("lastKnownLocation.name")} 
                value={temporarySelection.find((col) => col.name === 'lastKnownLocation.name')?.value}
                onValueChange={() => handleCheckboxChange('lastKnownLocation.name')}
              />
              &nbsp; Space
            </div>
            <div className='assets-columnCheckbox' >
              <CheckBox 
              value={temporarySelection.find((col) => col.name === 'event')?.value}
              onValueChange={() => handleCheckboxChange('event')}
              />
              &nbsp; Latest Event
            </div>
            <div className='assets-columnCheckbox' >
              <CheckBox 
              value={temporarySelection.find((col) => col.name === 'lastUpdate')?.value}
              onValueChange={() => handleCheckboxChange('lastUpdate')}
              />
              &nbsp; Location Update Time
            </div>
            <div className='assets-columnCheckbox' >
              <CheckBox 
              value={temporarySelection.find((col) => col.name === 'status')?.value}
              onValueChange={() => handleCheckboxChange('status')}
              />
              &nbsp; Status
            </div>

            <div className='assets-columnCheckbox' >
              <CheckBox 
              value={temporarySelection.find((col) => col.name === 'processState')?.value}
              onValueChange={() => handleCheckboxChange('processState')}
              />
              &nbsp; Process State
            </div>

            {tenant === 'c5a9b628-49ae-4f7c-9e5a-8909c07c47bb' ? <><div className='assets-columnCheckbox' >
              <CheckBox 
              value={temporarySelection.find((col) => col.name === 'motionDuration')?.value}
              onValueChange={() => handleCheckboxChange('motionDuration')}

              // value={showColumn("motionDuration")} 
              />
              &nbsp; Motion Duration(Last 7 days)
            </div>
            <div className='assets-columnCheckbox' >
              <CheckBox 
              value={temporarySelection.find((col) => col.name === 'motionDistance')?.value}
              onValueChange={() => handleCheckboxChange('motionDistance')}
              // value={showColumn("motionDistance")} 
              />
              &nbsp; Total Travel Distance(Last 7 days)
            </div></> : ""}
          </div>
        </ScrollView>
        <div className='movePopup'>
          <SelectButton onClick={selectColumn} className='movePopupSaveBtn' style={{ marginRight:"5%"}}>Ok</SelectButton>
          <SelectButton onClick={hideInfoColumn} className='movePopupSaveBtn' >Cancel</SelectButton>
        </div>
      </>
    )
  }

  // function showColumn(colName) {
  //   if (localStorage.getItem(tenant + "visibleCols") !== undefined && localStorage.getItem(tenant + "visibleCols") !== null) {
  //     var storedArray = JSON.parse(localStorage.getItem(tenant + "visibleCols"));
  //     let found = false
  //     for (let i = 0; i < storedArray.length; i++) {
  //       if (storedArray[i].name === colName) {
  //         found = true
  //         return storedArray[i].value
  //       }
  //     }
  //     if (!found) {
  //       storedArray.push({
  //         name: colName,
  //         value: false
  //       })
  //       localStorage.setItem(tenant + "visibleCols", JSON.stringify(storedArray));
  //       return false
  //     }
  //   } else {
  //     var storedArray2 = []
  //     storedArray2.push({
  //       name: colName,
  //       value: false
  //     })
  //     localStorage.setItem(tenant + "visibleCols", JSON.stringify(storedArray2));
  //     return false
  //   }
  // }
  function showColumn(colName) {
    if (localStorage.getItem(tenant + "visibleCols") !== undefined && localStorage.getItem(tenant + "visibleCols") !== null) {
      var storedArray = JSON.parse(localStorage.getItem(tenant + "visibleCols"));
      let found = false
      for (let i = 0; i < storedArray.length; i++) {
        if (storedArray[i].name === colName) {
          found = true
          return storedArray[i].value
        }
      }
      if (!found) {
        storedArray.push({
          name: colName,
          value: false
        })
        localStorage.setItem(tenant + "visibleCols", JSON.stringify(storedArray));
        return false
      }
    } else {
      var storedArray2 = []
      storedArray2.push({
        name: colName,
        value: false
      })
      localStorage.setItem(tenant + "visibleCols", JSON.stringify(storedArray2));
      return false
    }
  }

  function addMetres(rowData) {
    return rowData?.motionDistance?.toString() + "m";
  }

  function secondsToText(rowData) {
    const seconds = rowData?.motionDuration
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    // const remainingSeconds = seconds % 60;
    let result = "";
    if (hours > 0) {
      result += hours + " hour" + (hours > 1 ? "s" : "") + " ";
    }
    if (minutes > 0) {
      result += minutes + " minute" + (minutes > 1 ? "s" : "") + " ";
    }
    if (result === '') result = ``
    return result;
  }

  const onSelectionChanged = useCallback(({ selectedRowsData, selectedRowKeys }) => {
    console.log('[Assets] Selection saved:', selectedRowKeys);

    // Get the selected rows
    const selected = selectedRowsData;

    // Perform your custom action
    if (selected.length > 0) {
      setIsDisabled(false)
      setDisableClass("")
      // setSelectedRowsCount(selected.length)
    } else {
      setIsDisabled(true)
      setDisableClass("disable-analyze")
      // setSelectedRowsCount(0)
    }
  }, []);


  const WarningCellTemplate = (cellData) => {
    const { data } = cellData;  // Access the row data
    const status = data.status;

  const getImageForStatus = (status) => {
    if (status === 'offline') {
      return '../icons/risk-icon.svg';  // Add the actual path to your image for offline status
    } 
    return null
  };
  const imageSrc = getImageForStatus(status);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {imageSrc && (
      <img
        src={imageSrc}
        alt={status}
        title={"Caution: Device offline - location may be incorrect."}
        style={{ width: '20px', height: '20px', marginRight: '8px' }}  // Adjust size and margin as needed
      />
    )}
      <span style={{ marginLeft: imageSrc ? '0' : '28px' }}>{data.lastKnownLocation?.name}</span>  {/* Existing data is shown as it is */}
    </div>
  );
    
  };

  

  return (
    <>
    <div id="full-page-content-assets" className="page-content" style={{overflowY: "scroll"}} ref={downloadTargetRef}>
    <div className='headerHeadingPage'>
		  <div className='pageFullWidthEvents'>
        <h5 className='marginZeroEvents'>
          <b>Assets</b>
        </h5>
      <Popup
        visible={popupVisibleColumnChooser}
        onHiding={hideInfoColumn}
        dragEnabled={true}
        maxHeight={400}
        // width={250}
        width={300}
        shading={false}
        showCloseButton={true}
        showTitle={true}
        title={"Choose Columns"}
        container=".dx-viewport"
        key={'columnchooser'}
      >
        <Position
          at="right top"
          my="right top"
          offset="-200 160"
        />
        {chooserColumn()}
        
      </Popup>
      <Popup
        visible={popupVisible}
        onHiding={hideInfo}
        dragEnabled={false}
        showCloseButton={true}
        showTitle={true}
        title={spaceName}
        container=".dx-viewport"
        key={'spacename'}
      >
        <Position
          at="center"
          my="center"
        />
        {floorplan()}
      </Popup>
      <DataGrid
        id="gridContainer"
        noDataText={loadingText}
        showColumnLines={false}
        showRowLines={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode={'nextColumn'}
        columnMinWidth={80}
        columnAutoWidth={true}
        height={heightOfGrid}
        ref={dropDataGridRef}
        // onRowInserting={onRowInserting}
        onRowInserted={onRowInserted}
        onRowRemoved={onRowRemoved}
        onCellClick={showInfo}
        onCellPrepared={buttonColor}
        onRowUpdating={onRowUpdating}
        onEditorPreparing={onEditorPreparing}
        onEditCanceled={onEditCanceled}
        onInitialized={onInitialized}
        onExporting={exportGrid}
        dataSource={dataSource}
        onContentReady={handleOptionChanged}
        // onRowRemoving={handleRowRemoving}
        onToolbarPreparing={(e) => {
          // First: Clean up any existing buttons if needed
          e.toolbarOptions.items = e.toolbarOptions.items.filter(
            (item) => item.name !== 'addRowButton' && item.name !== 'exportButton'
          );
      
          // Then: Add custom Add (+) Button
          e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            cssClass: 'tight-toolbar-icon',
            options: {
              icon: '',
              text: '',
              stylingMode: 'text',
              // onClick: () => e.component.addRow(),
              onClick: () => handleAdd(),
              elementAttr: {
                id: 'addAssetTenantButton',
              },
              template: (buttonData, buttonElement) => {
                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.alignItems = 'center';
                container.style.justifyContent = 'center';
      
                container.innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                       viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                `;
                buttonElement.appendChild(container);
              },
            },
          });
      
          // Then: Add Export Button
          e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            cssClass: 'tight-toolbar-icon',
            options: {
              icon: 'exportxlsx',
              stylingMode: 'text',
              onClick: () => {
                // e.component.exportToExcel(false); // export all data
                exportGrid({ component: e.component });
              },
              elementAttr: {
                id: 'exportDataButton',
              },
            },
          });
        }}
      >
        <Scrolling mode="virtual" useNative={true}/>
        <Selection mode="multiple" showCheckBoxesMode="always" />
        <LoadPanel enabled={false} key={'loadpanel'} />
        <StateStoring enabled={true} type="localStorage" savingTimeout={0} storageKey={tenant + "assets"} ignoreColumnOptionNames={
          ["dataField", "dataType", "fixed", "fixedPosition",
            "groupIndex", "name", "sortIndex", "visible"]
        } key={'statestoring'}/>
        <Grouping autoExpandAll={true} />
        <Export
          enabled={true} 
          // texts={{exportAll:"Export All Data"}}
        />
        <Paging enabled={true} key={'paging'}/>
        <Editing
          // allowUpdating={true}
          allowUpdating={false}
          allowDeleting={false}
          allowAdding={false}
          // use-icons={true}
          // mode="popup"
          // key={'editing'}
          texts={{
            addRow: 'Add an Asset',
            confirmDeleteMessage:"Are you sure you want to delete this Asset?"
          }}
        >
        </Editing>
        <FilterRow visible={true} apply-filter="true" key={'filterRow'}/>
        <HeaderFilter visible={true} key={'headerfilter'}/>
        <SearchPanel visible={true} width="240" placeholder="Search..." onTextChange={onStatusUpdate} key={'searchAssets'} id="assets-list"/>
        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
        <Column
          dataField={DOMPurify.sanitize('name')}
          width={190}
          allowHiding={false}
          dataType='string'
          key={'name'}
          fixed={true}
        >
          <RequiredRule />
        </Column>
        <Column
          showInColumnChooser={false}
          dataField={DOMPurify.sanitize('type.id')}
          visible={false}
          dataType='string'
          key={'typeId'}
          fixed={true}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('type.name')}
          caption={'Type'}
          allowHiding={false}
          dataType='string'
          key={'typeName'}
          fixed={true}
        >
          <RequiredRule />
        </Column>
        <Column
          dataField={DOMPurify.sanitize('event')}
          caption={'Latest Event'}
          allowHiding={true}
          dataType='string'
          visible={showColumn('event')}
          key={'event'}
          id={'event'}
          fixed={true}
          allowFiltering={true}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('motionDistance')}
          caption={'Distance Travelled[m] (Last 7 days)'}
          dataType='string'
          visible={showColumn('motionDistance')}
          key={'motionDistance'}
          // calculateDisplayValue={addMetres}
          fixed={true}
          allowHiding={true}
          allowFiltering={false}
        ></Column>
        <Column
          dataField={DOMPurify.sanitize('motionDuration')}
          caption={'Motion Duration(Last 7 days)'}
          dataType='string'
          visible={showColumn('motionDuration')}
          calculateDisplayValue={secondsToText}
          key={'motionDuration'}
          fixed={true}
          allowHiding={true}
          allowFiltering={false}
        ></Column>
        <Column
          dataField={DOMPurify.sanitize('status')}
          caption={'Status'}
          dataType='string'
          visible={showColumn('status')}
          key={'status'}
          fixed={true}
          allowHiding={true}
        ></Column>
        <Column
          dataField={DOMPurify.sanitize('pairedDevice.id')}
          showInColumnChooser={false}
          dataType="string"
          visible={false}
          key={'pairedDeviceId'}
          fixed={true}
        ></Column>
        <Column
          dataField={DOMPurify.sanitize('pairedDevice.serialNumber')}
          caption={'Paired Tag'}
          visible={showColumn('pairedDevice.serialNumber')}
          key={'pairedDevice.serialNumber'}
          dataType="string"
          fixed={true}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('lastKnownLocation.name')}
          caption={'Space'}
          allowHiding={true}
          dataType='string'
          visible={showColumn('lastKnownLocation.name')}
          key={'lastKnownLocationName'}
          fixed={true}
          cellRender={WarningCellTemplate}
        />
        <Column
          dataField={DOMPurify.sanitize('lastKnownLocation.timestamp')}
          allowSorting={true}
          allowFiltering={true}
          dataType="datetime"
          format="EEE MMM dd yyyy, hh:mm a"
          caption={'Location Update Time'}
          visible={showColumn('lastUpdate')}
          key={'lastKnownLocationTimestamp'}
          fixed={true}
          editorOptions={{
            dropDownOptions: {
              container: document.body
            }
          }}
        />
        <Column
          dataField={DOMPurify.sanitize('processState')}
          caption={'Process State'}
          visible={showColumn('processState')}
          key={'processState'}
          dataType="string"
          fixed={true}
        />

        <Column type="buttons" width={110} key="actionButtons" fixed={true}
          >
            <Button
              hint="Edit"
              icon="edit"
              onClick={editRow}
            />
            <Button
              hint="Delete"
              icon="trash"
              onClick={handleDeleteClick}
            />
          </Column>
        {/* <Column
          type="buttons"
        ]-[p
        O":Iluwidth={100}
        \=buttons={[QWZSrdytuxf ghiyvcbcjnk;ml',.;/

            {
              hint: 'Delete',
              icon: 'trash',
              onClick: (e) => {
                e.event.preventDefault(); // Avoid default behavior
                handleDeleteClick(e.row.data);
              },
            },
            // 'edit',
          ]}
        /> */}
        {showAttributes()}
        <Summary visible={false} />
      </DataGrid>
      <Tooltip
        target="#addAssetTenantButton"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="bottom"
      >
        <div className="custom-tooltip">Add an Asset</div>
      </Tooltip>
      <Tooltip
        target="#exportDataButton"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="bottom"
      >
        <div className="custom-tooltip">Export All Data</div>
      </Tooltip>
      <LoadingPanel
        shadingColor="rgba(34, 31, 31, 0.4)"
        visible={loading}
        showIndicator={true}
        showPane={true}
        shading={true}
        hideOnOutsideClick={false}
      />
      <div className={`uploadBtnAssetsReport upload55 ${disableClass}`}>
        <button id="generatePdfButtonAnalyse" alt="Analyze Assets" type="button" onClick={getMultipleSelection} > 
          <img src="../icons/glassIcon.svg" alt="Analyze Assets" />
        </button>
        <Tooltip
          target="#generatePdfButtonAnalyse"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
          // visible={true}
        >
          <div className="custom-tooltip">Analyze Assets</div>
        </Tooltip>

      </div>
      <div className='uploadBtnAssetsReport upload44'>
        <button id="generatePdfButtonReportAnalyse" alt="Summarize" type="button" onClick={exportData}>
          <img src="../icons/pivot-table.svg" alt="Summarize"  style={{height: '32px', width: '32px'}}/>
        </button>
        <Tooltip
          target="#generatePdfButtonReportAnalyse"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
        >
          <div className="custom-tooltip">Summarize</div>
        </Tooltip>
      </div>
      <div className='uploadBtnAssetsReport upload3-assets'>
        <button id="generatePdfButton" alt="Download Report" type="button" onClick={downloadReport}>
          <img src="../icons/reports.svg" alt="Download Report" />
        </button>
        <Tooltip
          target="#generatePdfButton"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
        >
          <div className="custom-tooltip">Download Report</div>
        </Tooltip>
      </div>
      <div className="uploadBtnAssets upload1" id="downloadReportAssets" onClick={uploadClick} key={'uploadbtnassetsbtns'}>
        <i className="dx-icon-upload" style={{ "fontSize": "28px" }}></i>
        <Tooltip
          target="#downloadReportAssets"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
        >
          <div className="custom-tooltip">Upload Assets</div>
        </Tooltip>
      </div>
      {/* <div className="uploadBtnAssets2 upload2" title={"Choose Columns"} onClick={columnChooser} key={'uploadbtnassets2linker'}>
        <i className="dx-icon-columnchooser" style={{ "fontSize": "24px" }}></i>
      </div> */}
      <div className='uploadBtnAssets2 upload2'>
        <button id="columnChooserBtn" alt="Choose Columns" type="button" onClick={columnChooser}>
          <img src="../icons/columns.svg" alt="Choose Columns" style={{ width: '26px', height: '26px' }} />
        </button>
        <Tooltip
          target="#columnChooserBtn"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
        >
          <div className="custom-tooltip">Choose Columns</div>
        </Tooltip>
      </div>
      <Popup
        visible={uploadPopupVisible}
        onHiding={onHidingUpload}
        dragEnabled={false}
        height={150}
        width={600}
        showCloseButton={true}
        showTitle={true}
        title="Upload CSV"
        container=".dx-viewport"
        key={'uploadCsv'}
      >
        {Form2()}
      </Popup>
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
        key={'toast'}
      />
      </div>
      </div>
    </div>

    <SlidingDrawer
      // title="Add Asset"
      title={`${formData?.id ? "Edit" : "Add"} Asset`}
      isOpen={isOpen}
      onClose={handleCloseDrawer}
      handleSave={handleSave}
      formData={formData}
      prevData={prevData}
    >
      {isOpen &&
      <form ref={formRef} onSubmit={handleSubmit}>
        <div>
          <DxForm
            formData={formData}
            onFieldDataChanged={(e) => {
              setFormData((prev) => ({
                ...prev,
                [e.dataField]: e.value,
              }));
              if (e.dataField === 'type' && e.value) {
                AssetsService.getAssetTypeAttributes(e.value).then((res) => {
                  setAttributeFields(res.data.data || []);
                  setFormData(prev => ({ ...prev, attributes: {} }));
                });
              }
            }}
            onInitialized={(e) => {
              dxFormRef.current = e.component;
            }}
            labelLocation="top"
            showColonAfterLabel={false}
            showValidationSummary={false}
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="name"
                editorType="dxTextBox"
                editorOptions={{
                  valueChangeEvent: 'input',
                }}
                validationRules={[{ type: 'required', message: 'Name is required' }]}
              >
                <Label text="Name" isRequired />
              </SimpleItem>

              <SimpleItem
                dataField="type"
                editorType="dxSelectBox"
                editorOptions={{
                  items: positionEditorOptions?.items || [],
                  displayExpr: 'name',
                  valueExpr: 'id',
                  placeholder: 'Select...',
                  searchEnabled: true,
                  dropDownOptions: {
                    container: '.slide-pane'
                  },
                  itemRender: (item) => (
                    <div className="custom-item">
                      <div className="product-name">{item.name}</div>
                    </div>
                  ),
                }}
                validationRules={[{ type: 'required', message: 'Asset Type is required' }]}
              >
                <Label text="Asset Type" isRequired />
              </SimpleItem>

              <SimpleItem
                dataField="pairedDevice"
                editorType="dxSelectBox"
                editorOptions={{
                  items: deviceEditorOptions?.dataSource || [],
                  displayExpr: 'serialNumber',
                  valueExpr: 'id',
                  placeholder: 'Select a device',
                  // showClearButton: true,
                  searchEnabled: true,
                  dropDownOptions: {
                    container: '.slide-pane'
                  }
                }}
                validationRules={[{ type: 'required', message: 'Paired Device is required' }]}
              >
                <Label text="Paired Device" isRequired />
              </SimpleItem>
            </GroupItem>
          </DxForm>
          {attributeFields.length > 0 && (
            <>
              <div style={{ margin: '20px 0 8px', fontWeight: 600, fontSize: '13px' }}>Attributes</div>
              <DxForm
                formData={formData.attributes || {}}
                onFieldDataChanged={(e) => {
                  setAttributeChanges((prev) => ({ ...prev, [e.dataField]: e.value }));
                }}
                labelLocation="top"
                showColonAfterLabel={false}
              >
                <GroupItem colCount={1}>
                  {attributeFields.map((field, i) => (
                    <SimpleItem key={i} dataField={field.name} />
                  ))}
                </GroupItem>
              </DxForm>
            </>
          )}
        </div>
      </form>
      }
    </SlidingDrawer>

    {/* Custom Delete Confirmation Popup */}
    <Popup
      visible={deleteConfirmVisible}
      onHiding={cancelDelete}
      dragEnabled={false}
      height={150}
      width={400}
      showCloseButton={true}
      showTitle={false}
      title="Confirm Delete"
      container=".dx-viewport"
    >
      <Position
        at="center"
        my="center"
      />
      <div style={{ padding: '0px', textAlign: 'center' }}>
        <p style={{ fontSize: '16px' }}>
          Are you sure you want to delete the asset <strong>{assetToDelete?.name}</strong>?
        </p>
        <div style={{display: 'flex', justifyContent: 'center', gap: '0px', marginBottom: "5px"}}>
            <button style={{margin: 5}} className='profile-save' onClick={confirmDelete}>YES</button>
            <button style={{margin: 5}} className='profile-save' onClick={cancelDelete}>NO</button>
        </div>
      </div>
    </Popup>
    </>
  );
}
